import React from 'react';

import { CodeSnippet as Snippet } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').CodeSnippetBlock}
 */
const PullQuote = ({ html }) => {
    return (
        <section className='col-padding w-full'>
            <figure>
                <Snippet html={html} />
            </figure>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PullQuote;
